var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useCallback, useState } from 'react';
import Table from '../../../../components/Table/Table';
import Loading from '../../../../components/Loading';
import ShowMoreButton from '../../../../components/Table/components/ShowMoreButton';
import ExpandedMessage from '../ExpandedMessage';
import t from '../../../../lib/translate';
import MessageSearch from '../../hooks/MessageSearch';
var MessageList = function () {
    var _a = MessageSearch.useContainer(), isLoading = _a.isLoading, results = _a.results;
    var translate = useState(localStorage.getItem('translateTemplateKeys') ? localStorage.getItem('translateTemplateKeys') === 'true' : true)[0];
    var columns = useMemo(function () { return [
        {
            Header: t('messages.table.headers.channel'),
            accessor: 'channel'
        },
        {
            Header: t('messages.table.headers.recipient'),
            accessor: 'recipient'
        },
        {
            Header: t('messages.table.headers.id'),
            accessor: 'id'
        },
        {
            Header: t('messages.table.headers.timestamp'),
            id: 'created',
            accessor: function (row) { return new Intl.DateTimeFormat('nb', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            }).format(new Date(row.created)).toString(); }
        },
        {
            Header: t('messages.table.headers.status'),
            accessor: function (row) { return t("statuses.".concat(row.status)); }
        },
        {
            Header: t('messages.table.headers.template'),
            accessor: function (row) { return translate ? t("templates.key.".concat(row.templateKey)) : row.templateKey; }
        },
        {
            Header: t('messages.table.headers.template.version'),
            accessor: 'version'
        },
        {
            Header: '',
            expander: true,
            id: 'expander',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Cell: function (_a) {
                var row = _a.row;
                return (_jsx("span", __assign({}, row.getToggleRowExpandedProps, { onClick: function () { return row.toggleRowExpanded(); } }, { children: _jsx(ShowMoreButton, { open: !row.isExpanded, openText: t('general.open'), closeText: t('general.close') }) })));
            }
        }
    ]; }, [translate]);
    var expandedMessage = useCallback(function (_a) {
        var row = _a.row;
        return row.isExpanded
            ? (_jsx("td", __assign({ colSpan: columns.length, className: "expanded" }, { children: _jsx(ExpandedMessage, { id: row.values.id }) })))
            : null;
    }, [columns]);
    if (isLoading)
        return _jsx(Loading, {});
    return (_jsx("div", __assign({ className: "messageList" }, { children: _jsx(Table, { className: "message-list", columns: columns, data: results, pagination: true, pageSize: 100, searchField: results.length > 0, subRows: [expandedMessage] }) })));
};
export default MessageList;
